import TimeToPurchase from '../../cards/time-to-purchase';
import { Branch, Card } from '../../components/deck';

export default (continuation) =>
  Branch(
    {
      timeToPurchase: Card(TimeToPurchase)
    },
    ({ model }) => (!model.getIn(['loan', 'acceptedOffer']) ? 'timeToPurchase' : null),
    continuation
  );



// WEBPACK FOOTER //
// ./src/decks/branches/time-to-purchase-no-offer.js